import { render } from "./VsSelectItem.vue?vue&type=template&id=c9241c16"
import script from "./VsSelectItem.vue?vue&type=script&lang=js"
export * from "./VsSelectItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__